import {
  CREATE_CASE_FROM_ALERT_SUCCESS,
  CREATE_CASE_FROM_ALERT_FAIL,
  CREATE_CASE_FROM_ALERT,
  CLOSE_CASE_FROM_ALERT_INFO_MODAL,
  SELECT_ALERTS_FOR_ACTIONS,
  RESET_CONVERT_ALERTS_TO_CASE
} from '../../actions/cm/convertAlertsToCase';

export const initialState = {
  isLoading: false,
  isChangeAlertToCaseFailed: false,
  showInfoModal: false,
  selectedIds: [],
  errorMessage: '',
  caseId: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CREATE_CASE_FROM_ALERT:
      return {
        ...state,
        isChangeAlertToCaseFailed: false,
        showInfoModal: false,
        isLoading: true,
        errorMessage: ''
      };
    case CREATE_CASE_FROM_ALERT_SUCCESS:
      return {
        ...state,
        showInfoModal: true,
        isLoading: false,
        caseId: payload.caseId
      };
    case CREATE_CASE_FROM_ALERT_FAIL:
      return {
        ...state,
        isChangeAlertToCaseFailed: true,
        isLoading: false,
        errorMessage: payload
      };
    case CLOSE_CASE_FROM_ALERT_INFO_MODAL:
      return {
        ...state,
        showInfoModal: false,
        isChangeAlertToCaseFailed: false,
        isLoading: false
      };
    case SELECT_ALERTS_FOR_ACTIONS:
      return { ...state, selectedIds: payload };
    case RESET_CONVERT_ALERTS_TO_CASE:
      return {
        ...state,
        isChangeAlertToCaseFailed: false,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
}
